function Nav() {
    return (
      <nav className="navbar sticky-top nav">
        <a className="navbar-brand brand d-flex align-items-center" href="#">
          <img className="icon" src='https://schooltool.io/assets/img/logo.webp?h=0722d3247654ad6b5121ce1ebd28d5fc'></img>
          <b>School Tool</b>
        </a>
      </nav>
    );
  }

export default Nav; 